<template>
	<div>
		<div style="width: 100%">
			<el-row>
				<!-- <el-col :span="24"> -->
				<el-form :model="info" ref="info" :rules="rules" label-width="90px" style="height: 100%">
					<el-row>
						<el-col :span="6">
							<el-form-item label="试卷标题" prop="title">
								<el-input size="mini" v-model="info.title"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="试卷总分" prop="totalScore">
								<el-input size="mini" v-model="info.totalScore"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<el-form-item label="及格分数" prop="passScore">
								<el-input size="mini" v-model="info.passScore"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="绑定课时" prop="relatedCourseId">
								<el-cascader :disabled="disabled" size="mini" v-model="info.relatedCourseId"
									:options="options" :props="cateListProps" clearable @change="xzKZ" ref="tree"
									style="width: 300px" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="6">
							<el-form-item label="状态" prop="status" label-width="90px">
								<el-radio-group v-model="info.status">
									<el-radio :label="0">停用</el-radio>
									<el-radio :label="1">启用</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-button size="mini" type="primary" icon="el-icon-plus" @click="addQuestions(0)">选择
							</el-button>
							<!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="addQuestions(1)">填空
							</el-button> -->
							<el-col :span="10">当前共{{ info.options.length }}题</el-col>
						</el-col>
					</el-row>
					<el-row class="ques-row">
						<el-row v-for="(item, i) in info.options" :key="i">
							<el-col :span="16" :offset="4">
								<el-divider>
									<i class="el-icon-mobile-phone"></i>第{{i + 1}}题
								</el-divider>
							</el-col>
							<el-row>
								<el-col :span="16" :offset="4">
									<el-col :span="8">
										<el-form-item label="试题标题">
											<el-input size="mini" v-model="item.questionTitle"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="试题内容">
											<el-input size="mini" v-model="item.questionContext"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="7">
										<el-form-item label="正确答案">
											<el-select v-model="item.correctAnswer" placeholder="请选择" size="mini">
												<el-option v-for="(item,index) in xzOptions" :key="index"
													:label="item.value" :value="item.value">
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="1">
										<el-form-item v-if="info.options.length > 1">
											<el-button icon="el-icon-delete" size="mini" type="primary" @click="del(i)">
											</el-button>
										</el-form-item>
									</el-col>
								</el-col>
								<el-col :span="16" :offset="4">
									<el-col :span="8" v-if="item.questionType == 0"
										v-for="(option, index) in item.options" :key="index">
										<el-form-item :label="option.titie">
											<el-input size="mini" v-model="option.value"></el-input>
										</el-form-item>
									</el-col>
								</el-col>
							</el-row>
						</el-row>
					</el-row>
					<el-row v-if="this.info.options.length != 0">
						<div style="width: 100px; margin: 0 auto">
							<el-button @click="tj">提交</el-button>
						</div>
					</el-row>
				</el-form>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				disabled: false,
				questions: [],
				info: {
					relatedCourseName: "", //课程名称
					title: "", //标题
					relatedCourseId: "", //关联课程id
					status: "", //状态 0 -> false 停用 1---> true 启用
					totalScore: "", //总分
					passScore: "", //及格分数
					options: [],
				},
				xzOptions: [{
						value: 'A'
					},
					{
						value: 'B'
					},
					{
						value: 'C'
					},
					{
						value: 'D'
					}
				],
				rules: {
					title: [{
							required: true,
							message: "请输入试卷名称",
							trigger: "blur",
						},
						{
							min: 3,
							max: 15,
							message: "长度在 3 到 15 个字符",
							trigger: "blur",
						},
					],
					totalScore: [{
						required: true,
						message: "请输入试卷总分",
						trigger: "blur",
					}, ],
					passScore: [{
						required: true,
						message: "请输入及格分数",
						trigger: "blur",
					}],
					relatedCourseId: [{
						required: true,
						message: "请选择关联课时",
						trigger: "blur",
					}],
					status: [{
						required: true,
						message: "请选择状态",
						trigger: "blur",
					}],
				},
				options: [],
				cateListProps: {
					value: "lessonId", //匹配响应数据中的id
					label: "lessonName", //匹配响应数据中的name
					children: "clrLessonDOList", //匹配响应数据中的children
				},
			};
		},
		methods: {
			xzKZ(value) {
				console.log(value);
				this.info.relatedCourseId = value[value.length - 1];
				var name = this.$refs["tree"].getCheckedNodes()[0].pathLabels;
				this.info.relatedCourseName = name[name.length - 1];
				console.log(this.info.relatedCourseId, this.info.relatedCourseName);
			},
			del(index) {
				console.log(index);
				this.info.options.splice(index, 1);
			},
			getKc() {
				this.$http
					.post("/api/course/clrCourse/selectCourseList", {})
					.then((res) => {
						console.log(res.data.data);
						res.data.data.forEach((i) => {
							i.lessonId = i.courseId;
							i.lessonName = i.courseName;
						});
						this.options = res.data.data;
					});
			},
			addQuestions(type) {
				var ques = {
					questionTitle: "",
					questionContext: "",
					questionType: type,
					correctAnswer: "",
				};
				if (type == 0) {
					ques.options = [{
							titie: "A",
							value: "",
							index: 0,
						},
						{
							titie: "B",
							value: "",
							index: 1,
						},
						{
							titie: "C",
							value: "",
							index: 2,
						},
						{
							titie: "D",
							value: "",
							index: 3,
						},
					];
				}
				this.info.options.push(ques);
			},
			tj() {
				for (var i = 0; i < this.info.options.length; i++) {
					if (
						this.info.options[i].correctAnswer == "" ||
						this.info.options[i].questionContext[i] == "" ||
						this.info.options[i].questionTitle[i] == ""
					) {
						this.$message.error("试卷未填写完整！");
						return false;
					}
					// console.log(this.info.options[i].options);
					for (var a = 0; a < this.info.options[i].options.length; a++) {
						if (this.info.options[i].options[a].value == "") {
							this.$message.error("试卷未填写完整！");
							return false;
						}
					}
				}
				this.$refs.info.validate((valid) => {
					if (valid) {
						if (this.$route.query.cz == "tj") {
							// console.log("添加", this.info.relatedCourseId);
							this.$http
								.get(
									`/api/course/clrClasswork/check/${this.info.relatedCourseId}`, {}
								)
								.then((res) => {
									console.log(res.data.data);
									let checkNum = res.data.data
									if (res.data.data == 1) {
										console.log(1);
										this.$confirm("该课时已关联作业, 是否覆盖?", "提示", {
												confirmButtonText: "确定",
												cancelButtonText: "取消",
												type: "warning",
											})
											.then(() => {
												this.$http.post("/api/course/clrTestPaper/add/" +
														checkNum, {
															entity: {
																relatedCourseName: this.info
																	.relatedCourseName,
																title: this.info.title,
																relatedCourseId: this.info.relatedCourseId,
																status: this.info.status,
																totalScore: this.info.totalScore,
																passScore: this.info.passScore,
															},
															questionsEntities: this.info.options,
														})
													.then((res) => {
														console.log(res);
														if (res.data.status == 0) {
															this.$message.success("添加成功");
															this.$router.push("./test");
														}
													});
											})
											.catch(() => {
												this.$message({
													type: "info",
													message: "已取消",
												});
											});
									} else if (res.data.data == 2) {
										this.$confirm("该课时已关联试卷, 是否覆盖?", "提示", {
												confirmButtonText: "确定",
												cancelButtonText: "取消",
												type: "warning",
											})
											.then(() => {
												this.$http
													.post("/api/course/clrTestPaper/add/" + checkNum, {
														entity: {
															relatedCourseName: this.info
																.relatedCourseName,
															title: this.info.title,
															relatedCourseId: this.info.relatedCourseId,
															status: this.info.status,
															totalScore: this.info.totalScore,
															passScore: this.info.passScore,
														},
														questionsEntities: this.info.options,
													})
													.then((res) => {
														console.log(res);
														if (res.data.status == 0) {
															this.$message.success("添加成功");
															this.$router.push("./test");
														}
													});
											})
											.catch(() => {
												this.$message({
													type: "info",
													message: "已取消",
												});
											});
									} else if (res.data.data == 0) {
										this.$http
											.post("/api/course/clrTestPaper/add/" + checkNum, {
												entity: {
													relatedCourseName: this.info
														.relatedCourseName,
													title: this.info.title,
													relatedCourseId: this.info.relatedCourseId,
													status: this.info.status,
													totalScore: this.info.totalScore,
													passScore: this.info.passScore,
												},
												questionsEntities: this.info.options,
											})
											.then((res) => {
												console.log(res);
												if (res.data.status == 0) {
													this.$message.success("添加成功");
													this.$router.push("./test");
												}
											});

									}
								});
						} else if (this.$route.query.cz == "bj") {
							this.info.options.forEach((i) => {
								console.log(typeof i);
								i.testParerId = this.$route.query.id;
							});
							console.log("编辑", this.info.options);
							this.$http
								.post("/api/course/clrTestPaper/update", {
									entity: {
										relatedCourseName: this.info.relatedCourseName,
										title: this.info.title,
										relatedCourseId: this.info.relatedCourseId,
										status: this.info.status,
										totalScore: this.info.totalScore,
										passScore: this.info.passScore,
										id: this.$route.query.id,
									},
									questionsEntities: this.info.options,
								})
								.then((res) => {
									console.log(res);
									if (res.data.status == 0) {
										this.$message.success("编辑成功");
										this.$router.push("./test");
									}
								});
						}
					}
				});
			},
		},
		created() {
			this.getKc();
			if (this.$route.query.cz == "bj") {
				this.disabled = true
				this.$http
					.post("/api/course/clrExamQuestions/select", {
						testParerId: this.$route.query.id,
					})
					.then((res) => {
						console.log(res.data);
						this.info.title = this.$route.query.title;
						this.info.totalScore = this.$route.query.totalScore;
						this.info.passScore = this.$route.query.passScore;
						this.info.relatedCourseId = this.$route.query.relatedCourseId;
						this.info.relatedCourseName = this.$route.query.relatedCourseName;
						this.info.status = this.$route.query.status;
						let newData = res.data.data;
						this.info.options = [];
						newData.forEach((i) => {
							this.info.options.push({
								correctAnswer: i.correctAnswer,
								options: i.options,
								questionContext: i.questionContext,
								questionTitle: i.questionTitle,
								questionType: i.questionType,
							});
						});
						console.log(this.info.options);
					});
			}
		},
	};
</script>

<style scoped="scoped">
</style>
